import { hoursToUnits } from '@/helper/order.helper'
import type { OrderBucket } from '@/common/order.common'

const SERVICE_LABELS: Record<string, string> = {
  TOJ: 'TOJ',
  CONSULTING: 'Beratung',
  TRAINING: 'Schulung',
  PILOT: 'Pilot',
}

const SERVICE_UNIT_SUFFIXES: Record<string, string> = {
  TOJ: 'Stk.',
  CONSULTING: 'St.',
  TRAINING: 'T.',
  PILOT: 'Stk.',
}

export function formatCurrencyEUR(value: number) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0)
}

export function formatServiceScope(buckets: OrderBucket[]) {
  return buckets
    .filter(b => (b.plannedHours ?? 0) > 0)
    .map(b => {
      const label = SERVICE_LABELS[b.serviceType] ?? b.serviceType
      const units = hoursToUnits(b.serviceType, b.plannedHours ?? 0)
      return `${label}: ${units}`
    })
    .join(' · ')
}

/**
 * Order years the overview can filter by, newest first (SIB-1073). GET /orders accepts the
 * previous, current and next year; the next year only holds orders once Union has opened it for
 * planning (SIB-928), so it is offered from then on.
 */
export function getOrderYearOptions(currentYear: number, openYears: number[]): number[] {
  const years = [currentYear, currentYear - 1]
  if (openYears.includes(currentYear + 1)) years.unshift(currentYear + 1)
  return years
}

export type ServiceBadge = {
  serviceType: string
  label: string
  value: string
}

export function getServiceBadges(buckets: OrderBucket[]): ServiceBadge[] {
  return buckets
    .filter(b => (b.plannedHours ?? 0) > 0)
    .map(b => {
      const units = hoursToUnits(b.serviceType, b.plannedHours ?? 0)
      const suffix = SERVICE_UNIT_SUFFIXES[b.serviceType] ?? 'Stk.'
      return {
        serviceType: b.serviceType,
        label: SERVICE_LABELS[b.serviceType] ?? b.serviceType,
        value: `${units} ${suffix}`,
      }
    })
}
